module.exports = __webpack_public_path__ + "img/GreekTechSarissophoroiS_ua.c1c4cd10.webp";